import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PopUpSlider from "../../components/PopUpSlider/PopUpSlider";
import StoreInfo from "../../features/Landing/components/StoreInfo/StoreInfo";
import QuickMenu from "../../components/QuickMenu/QuickMenu";
import Promotion from "../../components/Promotion/Promotion";
import LandingButton from "../../features/Landing/components/LandingButton";
import FindStoreAround from "../../features/Landing/components/FindStoreAround/FindStoreAround";
import FindStoreModal from "../../features/Landing/components/Modal/FindStoreModal";
import iconCall from "../../assets/icon_call.svg";
import icon1on1 from "../../assets/icon_1on1.svg";
import landersLogo from "../../assets/landers_logo.svg"

import useStoreInform from "#features/Landing/hooks/useStoreInform";
import usePromotion from "#features/Landing/hooks/usePromotion";
import useQuickMenu from "#hooks/quickMenu/useQuickMenu";
// import useQuickMenu from "../../hooks/quickMenu/useQuickMenu";
import StoreInfoSkeleton from "../../components/Skeleton/StoreInfoSkeleton";
import QuickMenuSkeleton from "../../components/Skeleton/QuickMenuSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { initDestination } from "#src/modules/reducers/destination/destination.js";
import useReactGASend from "../../hooks/useReactGASend";
import useCheckChatStatus from "#src/features/Incomming/hooks/useCheckChatStatus.js";
import ServiceAlert from "#src/components/ServiceAlert/ServiceAlert.jsx";

const LandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { makeEventTrackFn } = useReactGASend();

  useCheckChatStatus(); // Uncomment if this hook is required
  const [modalIsOpen, setIsOpen] = useState(false);
  const isPageHeightGreaterThan200vh = document.body.scrollHeight > window.innerHeight;
  const to = useSelector((state) => state.destination.to);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const {
    branchName,
    storeClose,
    workingTime,
    location: branchLocation,
    needSelectBranch,
    isOpen,
    cashless,
    loading: storeInfoLoading,
    fc,
    brandId,
    homeAway,
    stadium
  } = useStoreInform();
  const { landingItems, popUpItems } = usePromotion();
  const { menuItems, loading: quickMenuLoading } = useQuickMenu();
  const isLanders = brandId === "LD";

  useEffect(() => {
    makeEventTrackFn({ category: "event", action: "랜딩페이지 인입" });
    
    const handlePageRefresh = (e) => {
      makeEventTrackFn({ category: "event", action: "랜딩페이지 인입" });
    };
    window.addEventListener("beforeunload", handlePageRefresh);
    return () => {
      window.removeEventListener("beforeunload", handlePageRefresh);
    };
  }, []);

  useEffect(() => {
    const handlePopState = (e) => {
      if (!to) {
        navigate("/exit");
      } else {
        dispatch(initDestination());
      }
    };
    setTimeout(() => {
      window.history.pushState(null, "", location.pathname);
      window.addEventListener("popstate", handlePopState);
    }, 500);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate, to]);

  return (
    <>
      <main className="py-4 pb-24 pt-14">
        {isLanders && (
          <div className="flex flex-row justify-between px-6 mt-[-18px]">
            <img src={landersLogo} alt="랜더스로고" className="w-[80px] h-16" />
            <div className="flex flex-row items-center justify-center gap-2 py-2 ">
              <a
                className="w-8 h-6 flex items-center justify-center"
                href="https://www.ssglanders.com/deepLink/qna"
                onClick={() => {
                  makeEventTrackFn({ category: "event", action: "1:1 상담" });
                }}
                title="1:1 상담"
              >
                <img src={icon1on1} alt="1:1 상담" className="w-8 h-8" />
              </a>
              <a 
                className="w-8 h-6 flex items-center justify-center" 
                href={"tel:032-455-2600"} 
                onClick={() => {
                  makeEventTrackFn({ category: "event", action: "고객센터" });
                }}
                title="고객센터"
              >
                <img src={iconCall} alt="고객센터" className="w-8 h-8" />
              </a>
            </div>
          </div>
        )}
        {needSelectBranch && <FindStoreAround />}
        <div className="px-4">
          {storeInfoLoading ? (
            <StoreInfoSkeleton />
          ) : (
            !needSelectBranch && (
              <StoreInfo
                branchName={branchName}
                storeClose={storeClose}
                workingTime={workingTime}
                location={branchLocation}
                isOpen={isOpen}
                cashless={cashless}
                fc={fc}
                homeAway={homeAway}
                stadium={stadium}
              />
            )
          )}
        </div>
        {quickMenuLoading ? (
          <div className="px-4">
            <QuickMenuSkeleton />
          </div>
        ) : (
          <QuickMenu
            menuItems={menuItems}
            needSelectBranch={needSelectBranch}
            openModal={openModal}
          />
        )}
        <div className="px-4 relative z-[5]">
          <Promotion promoItems={landingItems} />
        </div>
        {!needSelectBranch && <LandingButton />}
        {popUpItems?.length > 0 && <PopUpSlider items={popUpItems} />}
        {(brandId === "EM" || brandId === "TR") && <ServiceAlert />}
        <FindStoreModal isOpen={modalIsOpen} onRequestClose={closeModal} />
      </main>
      {
        isLanders ? (
        <div className={`${isPageHeightGreaterThan200vh ? 'relative' : 'fixed'} max-w-[680px] w-full pt-8 pb-2 px-5 justify-end bottom-2 flex gap-2 text-sm font-medium break-words text-gray-600`}>
          <span className="font-bold text-white"><a href="https://www.ssglanders.com/policy?pos=0&type=1" target="_blank" title="개인정보처리방침" rel="noreferrer">개인정보처리방침</a></span>
          <a className="font-bold text-white" href="https://www.ssglanders.com/policy?pos=0&type=2" target="_blank" title="이용약관" rel="noreferrer">이용약관</a>
          <span className="font-bold text-white"><a href="https://www.ssglanders.com/policy?pos=0&type=3" target="_blank" title="이메일무단수집거부" rel="noreferrer">이메일무단수집거부</a></span>
        </div>
        ) : (
        <div className={`${isPageHeightGreaterThan200vh ? 'relative' : 'fixed'} max-w-[680px] w-full pt-8 pb-2 px-5 justify-end bottom-2 flex gap-2 text-sm font-medium break-words text-gray-600`}>
          <a href="https://eapp.emart.com/member/agreement.do" target="_blank" title="이용약관" rel="noreferrer">이용약관</a>
          <span className="font-bold text-red-400"><a href="https://eapp.emart.com/member/personal_info.do" target="_blank" title="개인정보처리방침" rel="noreferrer">개인정보처리방침</a></span>
          <span className="font-bold text-red-400"><a href="https://store.emart.com/member/processing_info.do" target="_blank" title="영상정보처리기기운영,관리방침" rel="noreferrer">영상정보처리기기운영,관리방침</a></span>
        </div>
        )
      }
    </>
  );
};

export default LandingPage;
